'use client';
'use strict';

var React = require('react');

function NativeScrollArea({ children }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
}

exports.NativeScrollArea = NativeScrollArea;
//# sourceMappingURL=NativeScrollArea.cjs.map
